import { Component, input } from '@angular/core';

@Component({
	selector: 'vb-lxp-position-change-indicator',
	standalone: true,
	templateUrl: './position-change-indicator.component.html',
	styleUrl: './position-change-indicator.component.css',
})
export class PositionChangeIndicatorComponent {
	public state = input<'up' | 'down' | 'neutral' | undefined>('neutral');
}
